import { render, staticRenderFns } from "./SettingsTxSource.vue?vue&type=template&id=c2f9824c"
import script from "./SettingsTxSource.vue?vue&type=script&lang=js"
export * from "./SettingsTxSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports